import React from "react";
import { notify } from "@/shared/utils/notify";
import { accompanimentsService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import { IAccompaniment } from "../../../redux/@types";

export const useEditAccompaniment = ({
  accompaniment,
  onSuccess,
}: {
  accompaniment: IAccompaniment | undefined;
  onSuccess?: () => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const { control, handleSubmit: onSubmit, reset, watch, setValue } = useForm<any>({
    defaultValues: accompaniment
      ? {
          name: accompaniment.name,
          description: accompaniment.description,
          price: accompaniment.price,
          path_image: accompaniment.path_image,
        }
      : {},
  });

  React.useEffect(() => {
    if (accompaniment) {
      reset({
        name: accompaniment.name,
        description: accompaniment.description,
        price: accompaniment.price,
        path_image: accompaniment.path_image,
      });
    }
  }, [accompaniment, reset]);

  const handleSubmit = onSubmit(async (data: any) => {
    if (!accompaniment || loading) return;
    setLoading(true);
    await accompanimentsService
      .patch(accompaniment.id, {
        name: data.name,
        description: data.description,
        price: data.price,
        path_image: data.path_image,
      })
      .then(() => {
        notify.success("Acompañamiento actualizado correctamente");
        onSuccess?.();
      })
      .catch((err: any) => {
        notify.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  });

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
